'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.employeesServiceCenterToggle = twentyninetimes.employeesServiceCenterToggle || function () {

	function init() {
		const toggleClinics = document.querySelector('.block-employees-service-center-toggle__item--clinics');
		const toggleServicecenter = document.querySelector('.block-employees-service-center-toggle__item--servicecenter');
		const serviceCenterList = document.querySelector('.block-employees-full__list--servicecenter');
		
		if(toggleClinics && toggleServicecenter && serviceCenterList) {
			const dropdown = document.querySelector('.js-dropdown--employee-list');
			const dropdownButton = dropdown.querySelector('.dropdown__trigger');
			const clinicLists = document.querySelectorAll('.block-employees-full__list');
			const dropdownLabel = dropdown.querySelector(".dropdown__trigger-label");
			
			toggleClinics.addEventListener('click', function(e) {
				toggleServicecenter.classList.remove('block-employees-service-center-toggle__item--active');
				toggleClinics.classList.add('block-employees-service-center-toggle__item--active');
				serviceCenterList.classList.add('hidden');
				dropdown.classList.remove('disabled');
				dropdownButton.disabled = false;
			});

			toggleServicecenter.addEventListener('click', function(e) {
				
				clinicLists.forEach((clinicList) => {
					clinicList.classList.add('hidden');
				});

				dropdownLabel.innerHTML = 'Vælg by';

				toggleClinics.classList.remove('block-employees-service-center-toggle__item--active');
				toggleServicecenter.classList.add('block-employees-service-center-toggle__item--active');
				serviceCenterList.classList.remove('hidden');
				dropdown.classList.add('disabled');
				dropdownButton.disabled = true;
			});
		}
	}

	return {
		init : init
	};

}();